module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"order":{"product_options":"선택: {0}"}}}')
  delete Component.options._Ctor
}
